module.exports = __webpack_public_path__ + "static/img/game-Horizon-Zero-Dawn_phone.cb5e73c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/game-Horizon-Zero-Dawn_phone.jpg
// module id = tL25
// module chunks = 0